import {
    SET_SOLAR_INPUTS_IS_OPEN,
    SET_SOLAR_INPUTS_SOLAR_INPUTS_TOGGLE,
} from './constants';

export const setSolarInputsIsOpen = isOpen => ({
    type: SET_SOLAR_INPUTS_IS_OPEN,
    isOpen,
});

export const setSolarInputsToggle = solarInputsToggle => ({
    type: SET_SOLAR_INPUTS_SOLAR_INPUTS_TOGGLE,
    solarInputsToggle,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/SolarInputs/actions.js